<nav aria-label="breadcrumb">
  <ol class="breadcrumb mb-0 pl-0">
    <li *ngFor="let item of items; let idx = index" id="{{item.id}}" class="breadcrumb-item">      
      <span *ngIf="idx == items.length - 1">{{item.title}}</span>
      <a *ngIf="idx < items.length - 1" (click)="onClick($event, item)" href="#">{{item.title}}</a>
    </li>
  </ol>
</nav>